import type { ConversationSurface } from '@/lib/api';
import { cn } from '@/lib/utils';
import { SURFACES } from './surfaces';
import './surfaces.css';

export interface SurfaceIconProps {
  surface: ConversationSurface;
  size?: number;
  className?: string;
}

/** O ícone da origem, na cor dela. Decorativo: o nome vem sempre escrito ao lado (a tag). */
export function SurfaceIcon({ surface, size = 16, className }: SurfaceIconProps): JSX.Element {
  const Icon = SURFACES[surface].icon;
  return (
    <span className={cn('origem-icon', `origem-icon--${surface}`, className)} aria-hidden="true">
      <Icon size={size} />
    </span>
  );
}
